import { Box, Card } from "@mui/material";
import { display } from "@mui/system";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { itemContent } from "examples/Sidenav/styles/sidenavItem";
import React, { useEffect, useRef, useState } from "react";

const GoogleMapComponent = React.forwardRef(
  ({ lat, lng, edit = false, onLocationChange }, ref) => {
    const mapRef = ref || useRef(null);
    const [location, setLocation] = useState({
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    });

    useEffect(() => {
      const initMap = () => {
        const pinLocation = { lat: location.lat, lng: location.lng };
        const map = new window.google.maps.Map(mapRef.current, {
          zoom: 20,
          center: pinLocation,
        });
        const marker = new window.google.maps.Marker({
          position: pinLocation,
          map: map,
          title: "My Pin",
        });

        // Listen for map clicks to set a new marker
        if (edit) {
          map.addListener("click", (e) => {
            const clickedLatLng = e.latLng;
            const newLatLng = {
              lat: clickedLatLng.lat().toFixed(8),
              lng: clickedLatLng.lng().toFixed(8),
            };

            setLocation(newLatLng);
            marker.setPosition(clickedLatLng);
            map.panTo(clickedLatLng);
          });
        }
      };

      const loadGoogleMapScript = () => {
        if (window.google && window.google.maps) {
          initMap(); // Call initMap if Google Maps API is already loaded
        } else {
          window.initMap = initMap; // Define initMap globally
          const script = document.createElement("script");
          script.src =
            process.env.REACT_APP_ENV === "prod"
              ? `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAP_API_KEY}&callback=initMap`
              : `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAP_API_KEY}&callback=initMap`;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);

          return () => {
            // Clean up the script when the component unmounts
            document.head.removeChild(script);
          };
        }
      };

      loadGoogleMapScript();
    }, [lat, lng]);

    const handleAddressChange = async () => {
      const isConfirmed = window.confirm("Are you sure you want to save this address?");
      if (isConfirmed) {
        onLocationChange(location);
      }
    };

    return (
      <Card
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%", // Set the desired width here
          backgroundColor: "white",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        {edit && (
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Box sx={{ display: "flex", gap: 2 }}>
              <MDTypography variant="h6">Latitude: {location.lat}</MDTypography>
              <MDTypography variant="h6">
                Longitude: {location.lng}
              </MDTypography>
            </Box>
            <MDButton onClick={handleAddressChange} variant="contained">
              Change Pin
            </MDButton>
          </MDBox>
        )}
        <MDBox ref={mapRef} style={{ height: "40vh", width: "100%" }}></MDBox>
      </Card>
    );
  }
);

export default GoogleMapComponent;
